import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import NiceWrapper from 'components/NiceWrapper';
import { Flex, Box, Heading, Button } from 'rebass';
import { Label, Switch, Input } from '@rebass/forms';
import helpers from 'utils/helpers';
import helpersStudy from 'utils/helpers-study';
import helpersScreener from 'utils/helpers-screener';
import services from 'services/services';
import service_people from 'services/people';
import service_accounts from 'services/accounts';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';
import LoadingIndicator from 'components/LoadingIndicator';
import { useToasts } from 'react-toast-notifications';
import { useHistory } from 'react-router-dom';
import { ReactFormGenerator } from 'components/ReactFormBuilder';

function PanelistProfile(props) {
    const [loading, setLoading] = useState(true);
    const [personData, setPersonData] = useState({});
    const [account, setAccount] = useState({});
    const [panelForm, setPanelForm] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { addToast } = useToasts();
    const history = useHistory();

    useEffect(() => {
        checkPersonAuth();
        getAccountXHR();

        if (props.match.params.panel_form_id) {
            getPanelForm();
        }

    }, [props.match.params.account_uuid, props.match.params.panel_form_id]);


    function getPanelForm() {
        service_people
            .getPanelSignupPublic(props.match.params.account_uuid, props.match.params.panel_form_id)
            .then(response_panel_form => {
                //const { account, screener, screener_translation } = res_data;

                setPanelForm(response_panel_form);
                console.log('response_panel_form', response_panel_form)
            })
            .catch(error => {
                console.log(error);
            });
    }

    function getAccountXHR() {
        
        service_accounts
            .getAccountBySlug(props.match.params.account_uuid)
            .then(account => {
                setAccount(account);
                setLoading(false);
            })
            .catch(e => {
                console.log(e);
            });
    }

    function checkPersonAuth() {
        service_people
            .checkAuthPanelistExperience(props.match.params.account_uuid)
            .then(person => {
                //console.log('person', person);
                setPersonData(person);
            })
            .catch(e => {
                //console.log(e)
                redirectToPanelistLogin();
            });
    }

    function redirectToPanelistLogin() {
        history.push(`/panelist/${props.match.params.account_uuid}/login`);
    }

    function redirectToPanelistProfile() {
        history.push(`/panelist/${props.match.params.account_uuid}/profile`);
    }

    function checkShouldShowScreeners(account) {
        if (account && account.public_settings && account.public_settings.panelist_view_studies_allow) {
            return true;
        }
    }

    function logoutPersonAuth() {
        service_people
            .logoutPanelistExperience()
            .then(() => {
                redirectToPanelistLogin();
            })
            .catch(e => console.log(e));
    }

    function onFormSubmit(formAnswers) {
        console.log(formAnswers);

        setIsSubmitting(true);

        const screen_type = 'panel';

        services
            .editPanelProfileAnswers(props.match.params.account_uuid, props.match.params.panel_form_id, formAnswers, personData.uuid)
            .then(person => {
                addToast('Saved', {
                    appearance: 'success',
                    autoDismiss: true
                });
                setIsSubmitting(false);
                redirectToPanelistProfile();
            })
            .catch(error => {
                setIsSubmitting(false);

                console.log(error);
                const errorText = services.parseXhrErrors(error);

                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    return (
        <div style={{ margin: 'auto' }}>
            <Helmet titleTemplate="%s">
                <title>{account && account.title ? account.title : 'Panel Profile'}</title>
                {helpers.renderFavicon(account)}
            </Helmet>

            { loading ? (
                <Box my={4} style={{ width: '100%', height: '80px', position: 'relative' }}>
                    <LoadingWrapper>
                        <LoadingIndicator />
                    </LoadingWrapper>
                </Box>
            ) : account && account.title ? (
                <>
                    <Box style={{ textAlign: 'center'}} mt={4} mb={3}>
                        {account.logo ? (
                            <img src={account.logo} style={{ maxWidth: '100%', maxHeight: helpers.getPanelistLogoHeight(account) }} alt="Account Logo" />
                        ) : (
                            <div style={{height: '32px'}}></div>
                        )}
                        <Heading fontSize={[3, 4]} mt={2}><br/>Panelist Profile</Heading>
                    </Box>

                    <NiceWrapper style={{ background: 'white', color: 'black', padding: '0', margin: '0 32px' }}>
                        <Box p={4}>
                            <Box fontSize={1} style={{minWidth: '320px', maxWidth: '900px'}}>
                                
                                { personData && personData.uuid ?
                                    (panelForm && panelForm.screener)?
                                        (
                                            <>
                                                <Link to={`/panelist/${props.match.params.account_uuid}/profile`} style={helpers.accountThemeLinkStyle(account)}>
                                                    &lt; Back to profile
                                                </Link>
                                                <br/><br/>
                                                <ReactFormGenerator
                                                    data={panelForm.screener} // Question data
                                                    page_logic={panelForm.page_logic}
                                                    translation={panelForm.screener_translation}
                                                    branding={account.branding}
                                                    addpipe_token={account.addpipe_token}
                                                    addpipe_eid={account.addpipe_eid}
                                                    
                                                    person_defaults={personData ? personData.custom_data_values2 : null} // Question data
                                                    
                                                    action_name={
                                                        panelForm.screener_translation && panelForm.screener_translation.submit_button_text
                                                            ? panelForm.screener_translation.submit_button_text
                                                            : ''
                                                    }
                                                    back_name={
                                                        panelForm.screener_translation && panelForm.screener_translation.cancel_button_text
                                                            ? panelForm.screener_translation.cancel_button_text
                                                            : ''
                                                    }
                                                    is_required_name={
                                                        panelForm.screener_translation && panelForm.screener_translation.is_required_text
                                                            ? panelForm.screener_translation.is_required_text
                                                            : ''
                                                    }
                                                    dismiss_name={
                                                        panelForm.screener_translation && panelForm.screener_translation.dismiss_text
                                                            ? panelForm.screener_translation.dismiss_text
                                                            : ''
                                                    }
                                                    onSubmit={(formAnswers, isQualified) => { onFormSubmit(formAnswers, isQualified) }}
                                                    is_submitting={isSubmitting}
                                                />
                                            </>
                                        )
                                        :
                                        <>
                                            <strong>{helpers.personGetFullName(personData)}</strong><br/>
                                            {helpers.personGetEmail(personData)}
                                            
                                            {/*<Box mb={2} mt={4}><Label>Points</Label></Box>
                                            <Box>
                                                {personData.available_points} Points
                                                <Button variant='link' ml={3} style={helpers.accountThemeLinkStyle(account)}>Redeem</Button>
                                            </Box>*/}

                                            <Box mb={2} mt={4}><Label>Profile</Label></Box>
                                            {account && account.panel_forms ?
                                                account.panel_forms.map(pf => {
                                                    return <Flex mb={3} style={{justifyContent: 'space-between'}}>
                                                        <Link mt={2} to={`/panelist/${props.match.params.account_uuid}/profile/${pf.id}`} style={helpers.accountThemeLinkStyle(account)}>
                                                            {pf.title}
                                                        </Link>
                                                    </Flex>
                                                })
                                                : ''
                                            }
                                            <Box mb={2} mt={4}><Label>Invited studies</Label></Box>
                                            <Box>
                                                {personData.study_participation_basics.map(spb => {
                                                    return <Box className='border' mb={3} p={3}>
                                                        <strong>{spb.study_title}</strong><br/>
                                                        {spb.spot ?
                                                            <Box>
                                                                <Box mt={2}>Scheduled on {helpersStudy.displayStudyPersonSpotLocal(spb)}</Box>
                                                                {helpers.allowSPReschedule(account, spb) ?
                                                                    <Box>
                                                                        <a href={helpers.getSchedulingLink_reschedule(spb)} target="_blank" style={helpers.accountThemeLinkStyle(account)}>Reschedule</a>
                                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                                        <a href={helpers.getSchedulingLink_cancel(spb)} target="_blank" style={helpers.accountThemeLinkStyle(account)}>Cancel</a>
                                                                    </Box>
                                                                    :
                                                                    <></>
                                                                }
                                                            </Box>
                                                            :
                                                            <></>
                                                        }
                                                        {checkShouldShowScreeners(account) && spb && spb.screener_uuids && spb.screener_uuids.length > 0 ? (
                                                                <Box>
                                                                    <Box mb={2} mt={2}>Screeners</Box>
                                                                    {spb.screener_uuids.map(screener_uuid => {
                                                                        const study_person_temp = { uuid: spb.uuid };
                                                                        return <Box>
                                                                            <a href={helpersScreener.getScreenerLinkNewForPerson(screener_uuid, account, study_person_temp)} target="_blank" style={helpers.accountThemeLinkStyle(account)}>Open Screener</a>
                                                                        </Box>;
                                                                    })}
                                                                </Box>
                                                            )
                                                            :
                                                            <></>
                                                        }
                                                    </Box>
                                                })}
                                            </Box>
                                        </>
                                    :
                                        'Not found'
                                }

                                
                            </Box>
                        </Box>
                        <Box fontSize={1} p={3} sx={{textAlign: 'center', background: '#f7f7f7'}}>
                            <Button variant='link' className='muted' onClick={logoutPersonAuth}>Logout</Button>
                        </Box>
                    </NiceWrapper>
                    <br/><br/><br/><br/>
                </>
            ) : (
                <Box mt={4}>Account not found.</Box>
            )}
        </div>
    );
}

export default PanelistProfile;
